import React, { Component } from 'react';
import ErrorMessage from '../formElements/ErrorMessage';
import FormWrapper from '../formElements/FormWrapper';
import Input from '../formElements/Input';
import GenericModal from './GenericModal';
import * as Yup from 'yup';
import localeLookup from '../../config/locale';
import CheckboxGroup from '../CheckboxGroup';
import Field from '../formElements/Field';
import BoxMessage from '../BoxMessage';
import { ACCESS_LEVELS } from '../../constants';
import withAccessControl from '../HOC/withAccessControl';

class DuplicateTrainingSessionModal extends Component {
  constructor() {
    super();
    this.state = {
      isSubmitting: false,
    };
  }

  canEditAfterCreation = (values) => {
    const { hasAccess } = this.props;
    const hasAccessRoles = hasAccess([
      ACCESS_LEVELS.champadministrator,
      ACCESS_LEVELS.administrator,
      ACCESS_LEVELS.trainingSessionAdministrator,
    ]);

    if (hasAccessRoles) return true;
    if (values.include.includes('organisers')) return true;
    return false;
  };

  onSubmit = (values) => {
    const { onConfirm } = this.props;
    this.setState({ isSubmitting: true });
    onConfirm(values);
  };
  render() {
    const { isSubmitting } = this.state;
    const {
      onConfirm,
      confirmButtonText,
      inputPlaceholder,
      onCloseClick,
      title,
      defaultValue,
      subtitle,
      sessionName,
    } = this.props;
    return (
      <FormWrapper
        onSubmit={this.onSubmit}
        initialValues={{
          name: `${sessionName} (2)`,
          include: ['elements', 'trainers', 'participants', 'organisers'],
        }}
        validationSchema={Yup.object().shape({
          name: Yup.string().required(
            localeLookup('translations.Name is required')
          ),
        })}
      >
        {(props) => {
          const {
            errors,
            handleSubmit,
            values,
            dirty,
            handleChange,
            isValid,
            setFieldValue,
          } = props;
          return (
            <GenericModal
              confirmButtonText={confirmButtonText}
              onCancelClick={onCloseClick}
              onClose={onCloseClick}
              onConfirmClick={handleSubmit}
              title={title}
              subtitle={subtitle}
              confirmDisabled={!isValid || isSubmitting}
              message={
                !this.canEditAfterCreation(values)
                  ? {
                      type: 'warning',
                      text: localeLookup(
                        'translations.You have to include organisers to access the duplicated training session'
                      ),
                    }
                  : undefined
              }
            >
              <form onSubmit={handleSubmit}>
                <Field margin="lg" label={localeLookup('translations.Name')}>
                  <Input
                    autoFocus
                    fullWidth
                    placeholder={inputPlaceholder}
                    id="name"
                    name="name"
                    value={values.name}
                    onChange={handleChange}
                  />
                  <ErrorMessage show={errors.name}>{errors.name}</ErrorMessage>
                </Field>
                <CheckboxGroup
                  title={localeLookup('translations.Include')}
                  groupName="include"
                  initialCheckedValues={values.include}
                  onChange={(options) => setFieldValue('include', options)}
                  options={[
                    {
                      label: localeLookup('translations.Elements'),
                      id: 'elements',
                      value: 'elements',
                    },
                    {
                      label: localeLookup('translations.Trainers'),
                      id: 'trainers',
                      value: 'trainers',
                    },
                    {
                      label: localeLookup('translations.Participants'),
                      id: 'participants',
                      value: 'participants',
                    },
                    {
                      label: localeLookup('translations.Organisers'),
                      id: 'organisers',
                      value: 'organisers',
                    },
                  ]}
                />
              </form>
            </GenericModal>
          );
        }}
      </FormWrapper>
    );
  }
}

export default withAccessControl(DuplicateTrainingSessionModal);
